import React, {Component} from 'react';
import Swiper from 'swiper/dist/js/swiper';

import 'swiper/dist/css/swiper.css';

import './Hero2017.css';

export default class Hero2017 extends Component {
  componentDidMount() {
    new Swiper('.swiper-container-hero', {
      // Optional parameters
      speed: 800,
      effect: 'fade',
      loop: true,

      autoplay: {
        delay: 15000,
        disableOnInteraction: true
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        // dynamicBullets: true,
        clickable: true
      }
    })
  }

  render() {
    return (
        <div className="container-fluid our-service-container" id="hero"><div className="row">
        <div className="container">
          <div className="our-service">业务领域</div>
          <div className="swiper-container-hero">
            <div className="swiper-wrapper">
              <div className="swiper-slide hero-tech-advisory">
                <div className="intro col-xs-12">
                  <h3>技术咨询</h3>
                  <p>梳理业务需求，规划技术路线<br/>
                     制定实施方案，提供技术培训</p>
                </div>
              </div>
              <div className="swiper-slide hero-develop">
                <div className="intro col-xs-12">
                  <h3>系统开发</h3>
                  <p>科学管理开发流程、进度及质量<br/>
                     可按瀑布、敏捷、迭代等多种系统交付模式开展项目</p>
                </div>
              </div>
              <div className="swiper-slide hero-mno">
                <div className="tech-advisory intro col-xs-12">
                  <h3>系统运维</h3>
                  <p>预防系统漏洞，强化系统安全<br/>
                     提供客制化全方位运维服务</p>
                </div>
              </div>
            </div>
            <div className="swiper-pagination">

            </div>
          </div>
        </div>
        </div></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Hero2017.js